
import {Constants,ArrayUtil} from '../Constants';
import { CoordGeodetic } from '../../service/coord-helper.service';
import { FdmPlugin, FdmPluginInterface } from './plugins';

const Cesium = (<any>window).Cesium;

export class BoundingHandler extends FdmPlugin implements FdmPluginInterface {

    debug:boolean = Constants.debug_off;

    static meta = {
        label: 'PLUGINS.BOUNDING_GUIDE.LABEL',
        name: 'bounding-handler',
        tooltip: 'PLUGINS.BOUNDING_GUIDE.TOOLTIP',
        translator: 'PLUGINS.BOUNDING_GUIDE',

        category: FdmPlugin.category.internal,
        types: [ FdmPlugin.types.coordController ],
        features: [ FdmPlugin.features.show ]
    };

    show:boolean = true;
    
    // our boundary coordinates (should be GeodesicCoordinate[] )
    coords:CoordGeodetic[] = null;

    // track the maximum height (if it comes in)
    maxHeight:number = null;

    // shareable incoming original (often camera) coordinates
    originalCoords:CoordGeodetic[] = null;

    mapService:any = null;
    measureHelper:any = null;
    coordHelper:any = null;

    // any (non-tangled) initialising goes here
    init() {

        this.mapService = this.services.mapService;
        this.measureHelper = this.services.measureHelper;
        this.coordHelper = this.services.coordHelper;
        
        // we've got options
        this.setupOption ( 'type', [ 'Outline', 'Area', 'Wall' ]);

        // enforce priming to the boundary entity
        this.autoPrime = 'boundary';

        // ignore the boundary entity when show/hide the plugin (ie. always on)
        this.ignoreShowHide.boundary = true;
    }

    createScatterBoundery ( simpleCoords:CoordGeodetic[] = null ) {

        this.originalCoords = simpleCoords;

        let all = [];

        if ( simpleCoords ) {
            simpleCoords.forEach ( latLong => {
                this.coordHelper.getBoundingCoords ( latLong ).forEach ( geo => {
                    if ( geo ) {
                        all.push ( geo );
                    } 
                });
            });
            this.coords = this.coordHelper.createHullPolygon( all );
        }

        if ( this.debug ) { console.log ( '%c bounding.plugin %c createScatterBoundery() from=['+simpleCoords.length+'] scattered=['+all.length+'] boundary=['+this.coords.length+']', this.debugPrimary, this.debugSecondary ); }

    }

    updateCoords ( coords:CoordGeodetic[] = null, maxHeight:number = null ) {
        if ( !this.coordHelper ) {
            let me = this;
            setTimeout( () => { me.updateCoords ( coords, maxHeight ); }, 200 );
        } else {
            this.updateCoordsProper(coords,maxHeight);
        }
    }

    updateCoordsProper ( coords:CoordGeodetic[] = null, maxHeight:number = null ) {

        if ( this.debug ) { console.log ( '%c bounding.plugin %c updateCoords()', this.debugPrimary, this.debugSecondary, coords, maxHeight ); }

        // clean slate
        this.wipe ();

        let carts = null;

        if ( maxHeight ) {
            this.maxHeight = maxHeight;
        }

        // incoming coords?
        if ( coords ) {
            if ( coords[0] ) {
                if ( coords[0].hasOwnProperty('x') ) {
                    // assume cartesian
                    carts = coords;
                    this.coords = this.coordHelper.fromCartesians(coords);
                } else {
                    this.coords = coords;
                    carts = this.coordHelper.toCartesians(this.coords);
                }
            }
        }

        // we need coords to continue
        if ( ! this.coords ) {
            console.log ( '&^!%@^&%!@&^%!@^&!%@!&^ should not happen', this.options.type.current, this.maxHeight, this.show, this.coords );
            return;
        }

        this.entity ( 'boundary', this.mapService.viewer.entities.add ({
            name: 'bounding : wall',
            show: true,
            wall: {
                positions: this.coords,
                material: Cesium.Color.WHITE.withAlpha(0.01),
            }
        }) );

        this.primed = this.entity ( 'boundary' );

        let linearGeodesicArray = this.coordHelper.toLinearGeodesicArray( this.coords, true );
        let heights = Cesium.Cartesian3.fromDegreesArrayHeights( linearGeodesicArray );

        // what type are we?
        switch ( this.options.type.current ) {

            default:
            case 'Outline':

                let pos = this.coordHelper.cloneCoords ( this.coords, { height: 20 } );
                this.coordHelper.updateCartesians ( pos );

                // console.log ('!!!', this.coords, pos );

                this.entity ( 'primary', this.mapService.viewer.entities.add ({
                    name: 'bounding : outline : wall',
                    show: this.show,
                    wall: {
                        positions: pos,
                        outline: true,
                        outlineColor: Cesium.Color.BLACK,
                        outlineWidth: 4,
                        material: Cesium.Color.YELLOW.withAlpha(0.4),
                        clampToGround : true
                    }
                }));
/*
                this.entity ( 'primary', this.mapService.viewer.entities.add ({
                    name: 'bounding : outline : polyline',
                    show: this.show,
                    polyline: {
                        positions: heights,
                        width:4,
                        material: Cesium.Color.YELLOW.withAlpha(0.4),
                        outline: true,
                        outlineWidth: 3,
                        outlineColor: Cesium.Color.BLACK.withAlpha(0.3),
                    }
                }));
*/
                break;

                case 'Area':

                    this.entity ( 'primary', this.mapService.viewer.entities.add ({
                        name: 'bounding : area : polyline',
                        show: this.show,
                        polyline: {
                            positions: heights,
                            width:4,
                            material: Cesium.Color.BLACK.withAlpha(0.5),
                        }
                    }));
    
                    this.entity ( 'area', this.mapService.viewer.entities.add ({
                        name: 'bounding : area : polygon',
                        show: this.show,
                        polygon: {
                            hierarchy: carts,
                            material: new Cesium.GridMaterialProperty({
                                color : Cesium.Color.YELLOW.withAlpha(0.7),
                                cellAlpha : 0.1,
                            }),
                            heightReference: Cesium.HeightReference.NONE,
                        }
                    }));
    
                    break;
    
            case 'Wall':
            
                this.entity ( 'primary', this.mapService.viewer.entities.add ({
                    name: 'bounding : wall : wall',
                    show: this.show,
                    wall: {
                        positions: this.coords,
                        outline: true,
                        outlineWidth: 3,
                        outlineColor: Cesium.Color.ORANGE.withAlpha(0.7),
                        material: Cesium.Color.ORANGE.withAlpha(0.3),
                        // classificationType: Cesium.ClassificationType.BOTH,
                        clampToGround : false
                    }
                }));

                let points = [];

                this.coords.forEach ( p => {
                    let cart = this.coordHelper.toCartesian(p);
                    points.push ( this.mapService.viewer.entities.add ({
                        position: cart,
                        show: this.show,
                        point: {
                            pixelSize: 10,
                            color: Cesium.Color.BLACK.withAlpha(0.3),
                        }
                    }));
                });

                this.entity ( 'points', points );
                
                break;

        }

        // reset / update
        this.showHide( this.show );
        
    }

    // override to always use a specific entity (boundary is always on, so others can use it; it's a wall, so bounding box with matching height)
    flyTo() {
        super.flyTo('boundary');
    }

}
